const pattern = {
    digits: /^\d+$/,
    email: /^([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
}

const rulesValidation = {
    install(Vue) {
        Vue.forms = {
            bucketGoogle: (rule, value, callback) => {
                // https://cloud.google.com/storage/docs/naming#requirements
                if (/^(goog)/g.test(value)) {
                    callback(new Error('Bucket name cannot begin with "goog" prefix'))
                } else if (/(google)/g.test(value)) {
                    callback(new Error('Bucket name cannot contain "google"'))
                } else {
                    callback()
                }
            },

            bucketS3: (value, callback) => {
                // https://docs.aws.amazon.com/awscloudtrail/latest/userguide/cloudtrail-s3-bucket-naming-requirements.html
                // https://blogs.easydynamics.com/2016/10/24/aws-s3-bucket-name-validation-regex/
                const bucketS3 = /^([a-z]|(\d(?!\d{0,2}\.\d{1,3}\.\d{1,3}\.\d{1,3})))([a-z\d]|(\.(?!(\.|-)))|(-(?!\.))){1,61}[a-z\d.]$/

                if (!bucketS3.test(value)) {
                    callback(new Error('Bucket name is not valid'))
                } else {
                    callback()
                }
            },

            digits: (value, callback) => {
                if (!pattern.digits.test(value)) {
                    callback(new Error('Must be a number'))
                } else {
                    callback()
                }
            },

            email: (value, callback) => {
                if (!pattern.email.test(value) && value !== '') {
                    callback(new Error('e-mail address syntax is not correct'))
                } else {
                    callback()
                }
            },

            emails: (value, callback) => {
                let error = 0

                if (value.length > 0) {
                    const emails = value.replace(/\s/g, '').split(',')

                    for (const email of emails) {
                        if (!pattern.email.test(email) || email.length === 0) {
                            error++
                        }
                    }
                }
                if (error > 0) {
                    callback(new Error('e-mail address syntax is not correct'))
                } else {
                    callback()
                }
            },

            port: (value, callback) => {
                if (!pattern.digits.test(value)) {
                    callback(new Error('Must be a number'))
                } else if (value.length > 5) {
                    callback(new Error('Max length is 5 characters'))
                } else {
                    callback()
                }
            },

            text: (value, callback) => {
                const maxLength = 250
                if (typeof value !== 'undefined' && value !== null && value.length > maxLength) {
                    callback(new Error('Max length is ' + maxLength + ' characters'))
                } else {
                    callback()
                }
            },

            null: callback => {
                callback()
            }
        }
    }
}

export default rulesValidation
